import React from 'react';
import IconName from "../../../../svgLogo/SvgLogo";

const OrderInfo = () => {
    return (
        <div className="order-info-wrapper">
            <div className="info-title xpy-4 xpx-6 d-flex align-items-center">
                <span className="title">جزئیات سفارش </span>
                <span className="date persian-number">۹ مرداد ۱۳۹۹</span>
                <span className="code">SD-64215567</span>
            </div>
            <div className="info-body xpy-4 xpx-6">
                <div className="item address"><IconName name="location" className="icon"/><span
                    className="text persian-number">آذربایجان شرقی، تبریز، کوی گلشهر، خیابان گلگشت شرقی، پلاک ۵۱، طبقه‌ی ۴</span>
                </div>
                <div className="item user-name"><IconName name="user" className="icon"/><span
                    className="text">نام گیرنده : علی با وفا</span>
                </div>
                <div className="item phone-number"><IconName name="phone_in_talk" className="icon"/><span
                    className="text persian-number">شماره تماس : 09148877098</span>
                </div>
            </div>
        </div>
    );
};

export default OrderInfo;
